export default __webpack_public_path__ + "static/media/Our-Services1.d41f76fa.png";